import React from 'react';

import ReactDOM from 'react-dom';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'url-search-params-polyfill';

import { TestCaseFullScreenDialog } from '@qality/common-components';
import {
  TestCaseFullScreenCloseCallbackData,
  TestCaseFullScreenModalData,
} from '@qality/common-model/src/TestCaseFullScreenData';
import TestStepService from '@qality/common-service/src/TestStepService';

export default {
  openTestCaseFullScreenDialog(customData: TestCaseFullScreenModalData): void {
    const modalElem: HTMLElement = document.getElementById(
      'com_soldevelo_apps_test-management_full_screen_dialog'
    );

    const { qalityIssueViewContextInitProps, qalityIssueViewInitProps } =
      customData;

    qalityIssueViewInitProps.testCase.testSteps.testSteps =
      TestStepService.convertOriginObjectsToPromises(
        customData.qalityIssueViewInitProps.testCase
      );

    ReactDOM.render(
      <TestCaseFullScreenDialog
        qalityIssueViewContextInitProps={qalityIssueViewContextInitProps}
        qalityIssueViewInitProps={qalityIssueViewInitProps}
        onClose={async (data: TestCaseFullScreenCloseCallbackData) => {
          data.testCase.testSteps.testSteps =
            await TestStepService.convertOriginPromisesToObjects(data.testCase);
          customData.onFullScreenClose(data);
          closeModal();
        }}
      />,
      modalElem
    );
  },
};

const closeModal = () => {
  const remove: HTMLElement = document.querySelector(
    '#com_soldevelo_apps_test-management_full_screen_dialog'
  );
  ReactDOM.unmountComponentAtNode(remove);
};
